import { render, staticRenderFns } from "./AccountManagementRightDrawer.vue?vue&type=template&id=18840a06&scoped=true&"
import script from "./AccountManagementRightDrawer.vue?vue&type=script&lang=ts&"
export * from "./AccountManagementRightDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18840a06",
  null
  
)

export default component.exports